<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 查询 -->
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
    >
      <el-form-item label="员工姓名">
        <el-input
          v-model="searchForm.customerName"
          placeholder="请输入员工姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="员工角色">
        <el-select
          clearable
          v-model="searchForm.role"
          placeholder="请输入员工角色"
        >
          <el-option
            v-for="(v, i) in roleArr"
            :key="i"
            :label="v.name"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="员工电话">
        <el-input
          v-model="searchForm.phone"
          placeholder="请输入员工电话"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border);"
    >
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="searchForm.startTime"
          format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        至
        <el-date-picker
          v-model="searchForm.endTime"
          :picker-options="pickerOptionsEnd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList()">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <btns class="mgb-20" @exec="exec"></btns>
    <!-- 列表 -->
    <!-- 用户列表 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="tableSelectionChange"
    >
      <el-table-column type="selection" width="40"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="name" label="员工名称"> </el-table-column>
      <el-table-column prop="phone" label="员工电话"> </el-table-column>
      <el-table-column prop="type" label="员工角色">
        <template slot-scope="scope">
          <span
            v-text="scope.row.userRoleName ? scope.row.userRoleName : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" label="充值订单数"> </el-table-column>
      <el-table-column prop="phone" label="充值总金额">
        <template slot-scope="scope">
          <span
            v-text="
              (
                Number(scope.row.payMoney) + Number(scope.row.giveMoney)
              ).toFixed(2)
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="giveMoney" label="充值赠送金额"> </el-table-column>
      <el-table-column prop="payMoney" label="充值实付金额"> </el-table-column>

      <!-- <el-table-column prop="roleName" label="权限"> </el-table-column> -->
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0" type="danger" :underline="false">
            启用
          </div>
          <div v-if="scope.row.status == 1" :underline="false">
            禁用
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="80">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!--新增修改界面-->
    <el-dialog
      :title="funTit == 'add' ? '新增' : '修改'"
      :visible.sync="addORUpdateVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :rules="rules"
        :model="userForm"
        label-width="120px"
        ref="userForm"
      >
        <el-form-item label="电话号码" prop="phone">
          <el-input
            v-model="userForm.phone"
            auto-complete="off"
            placeholder="请输入电话号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="员工名称" prop="name">
          <el-input
            v-model="userForm.name"
            auto-complete="off"
            placeholder="请输入员工名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="员工角色" prop="role">
          <el-select
            v-model="userForm.role"
            clearable
            placeholder="请选择员工角色"
          >
            <el-option
              v-for="(v, i) in roleArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码" v-if="funTit == 'add'" prop="pwd">
          <el-input
            v-model="userForm.pwd"
            auto-complete="off"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" v-if="funTit == 'update'">
          <el-input
            v-model="userForm.newPwd"
            auto-complete="off"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" v-if="funTit == 'update'" prop="surePwd">
          <el-input
            v-model="userForm.surePwd"
            auto-complete="off"
            placeholder="请确认密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer center-footer">
        <el-button @click.native="addORUpdateVisible = false">取消</el-button>
        <el-button type="primary" @click="submit('userForm')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    const Name = (rule, value, callback) => {
      var reg = /^[\u4e00-\u9fa5]{0,}$/;
      if (!value) {
        callback(new Error("请输入员工姓名"));
      } else if (!reg.test(value)) {
        callback(new Error("姓名只支持中文，请重新输入"));
      } else {
        callback();
      }
    };
    const phone = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        callback(new Error("请输入员工电话"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号格式不正确，请重新输入"));
      } else {
        callback();
      }
    };
    const pwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (value.length < 6 || value.length > 11) {
        callback(new Error("密码在6-11位之间，请重新输入"));
      } else {
        callback();
      }
    };
    const surePwd = (rule, value, callback) => {
      if (value !== this.userForm.newPwd) {
        callback(new Error("两次密码不一致，请重新输入"));
      } else {
        callback();
      }
    };
    const role = (rule, value, callback) => {
      let reg = /^[\u4e00-\u9fa5]{0,}$/;
      if (!value) {
        callback(new Error("请输入职务"));
      } else if (!reg.test(value)) {
        callback(new Error("职务仅支持中文输入，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      searchForm: {
        customerName: "",
      },
      roleArr: [],

      tableSelection: [],
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      addORUpdateVisible: false,
      userForm: {
        phone: "",
        name: "",
        pwd: "",
        role: [],
        oldPwd: "",
        newPwd: "",
        surePwd: "",
      },
      funTit: "",
      rules: {
        // name: [{ required: true, validator: Name, trigger: "blur" }],
        name: [{ required: true, message: "请输入员工名称", trigger: "blur" }],

        phone: [{ required: true, validator: phone, trigger: "blur" }],
        role: [{ required: true, message: "请选择员工角色", trigger: "blur" }],
        pwd: [{ required: true, validator: pwd, trigger: "blur" }],
        surePwd: [{ validator: surePwd, trigger: "blur" }],
      },
      // roleArr: [],
      editRoleName: [],
    };
  },
  created() {
    this.getList();
    this.getRole();
  },
  watch: {
    "searchForm.startTime"() {
      if (this.searchForm.startTime == null) {
        this.searchForm.endTime = null;
      }
    },
  },
  methods: {
    // 去员工详情页面
    handleDetail(row) {
      this.$router.push({
        path: "/staff/staffDetail",
        query: {
          data: row,
        },
      });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.afterPeople
        .List({
          pageNum: this.page,
          pageSize: this.pageSize,
          name: this.searchForm.customerName,
          userRoleId: this.searchForm.role,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
          phone: this.searchForm.phone,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },

    submit(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          if (this.funTit == "add") {
            handleConfirm(`确认新增该员工吗？`, "info")
              .then(() => {
                // let roleNameArr = [];
                // this.userForm.role.forEach((v) => {
                //   this.roleArr.forEach((v2) => {
                //     if (v2.dictId === v) {
                //       roleNameArr.push(v2.dictName);
                //     }
                //   });
                // });
                this.$api.afterPeople
                  .add({
                    name: this.userForm.name,
                    password: this.userForm.pwd,
                    phone: this.userForm.phone,
                    userRoleId: this.userForm.role,
                    // roleName: roleNameArr.join(","),
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("新增成功", "success");
                      this.addORUpdateVisible = false;

                      this.getList();
                    }
                  });
              })
              .catch(() => {
                return;
              });
          } else {
            handleConfirm(`确认修改吗？`, "info")
              .then(() => {
                let roleIdArr = [];
                let roleNameArr = [];
                let id = null;
                let name = null;
                let id1 = null;
                let name1 = null;

                let id2 = null;
                let name2 = null;
                let reg = /^[\u4e00-\u9fa5]{0,}$/;
                // if (
                //   (reg.test(this.userForm.role[0]) &&
                //     reg.test(this.userForm.role[1]) &&
                //     reg.test(this.userForm.role[2])) ||
                //   (reg.test(this.userForm.role[0]) &&
                //     this.userForm.role[1] == null &&
                //     this.userForm.role[2] == null) ||
                //   (reg.test(this.userForm.role[0]) &&
                //     reg.test(this.userForm.role[1]) &&
                //     this.userForm.role[2] == null)
                // ) {
                //   this.userForm.role.forEach((v) => {
                //     this.roleArr.forEach((v2) => {
                //       if (v2.dictName === v) {
                //         roleIdArr.push(v2.dictId);
                //         roleNameArr.push(v2.dictName);
                //       }
                //     });
                //   });
                // } else if (
                //   (!reg.test(this.userForm.role[0]) &&
                //     !reg.test(this.userForm.role[1]) &&
                //     !reg.test(this.userForm.role[2])) ||
                //   (!reg.test(this.userForm.role[0]) &&
                //     this.userForm.role[1] == null &&
                //     this.userForm.role[2] == null) ||
                //   (!reg.test(this.userForm.role[0]) &&
                //     !reg.test(this.userForm.role[1]) &&
                //     this.userForm.role[2] == null)
                // ) {
                //   this.userForm.role.forEach((v) => {
                //     this.roleArr.forEach((v2) => {
                //       if (v2.dictId === v) {
                //         roleNameArr.push(v2.dictName);
                //         roleIdArr.push(v2.dictId);
                //       }
                //     });
                //   });
                // } else if (
                //   (reg.test(this.userForm.role[0]) &&
                //     !reg.test(this.userForm.role[1]) &&
                //     !reg.test(this.userForm.role[2])) ||
                //   (reg.test(this.userForm.role[0]) &&
                //     !reg.test(this.userForm.role[1]) &&
                //     this.userForm.role[2] == null) ||
                //   (reg.test(this.userForm.role[0]) &&
                //     reg.test(this.userForm.role[1]) &&
                //     !reg.test(this.userForm.role[2]))
                // ) {
                //   this.roleArr.forEach((v) => {
                //     if (v.dictName == this.userForm.role[0]) {
                //       id = v.dictId;
                //       name = v.dictName;
                //     } else if (
                //       !reg.test(this.userForm.role[1]) &&
                //       v.dictId == this.userForm.role[1]
                //     ) {
                //       id1 = v.dictId;
                //       name1 = v.dictName;
                //     } else if (
                //       reg.test(this.userForm.role[1]) &&
                //       v.dictName == this.userForm.role[1]
                //     ) {
                //       id1 = v.dictId;
                //       name1 = v.dictName;
                //     } else {
                //       if (!reg.test(this.userForm.role[2])) {
                //         if (v.dictId == this.userForm.role[2]) {
                //           id2 = v.dictId;
                //           name2 = v.dictName;
                //         }
                //       }
                //     }
                //     id2
                //       ? (roleIdArr = [id, id1, id2])
                //       : (roleIdArr = [id, id1]);
                //     // roleIdArr = [id, id1, id2];
                //     name2
                //       ? (roleNameArr = [name, name1, name2])
                //       : (roleNameArr = [name, name1]);
                //     // roleNameArr = [name, name1, name2];
                //   });
                // }
                // if (
                //   (reg.test(this.userForm.role[0]) &&
                //     reg.test(this.userForm.role[1])) ||
                //   (reg.test(this.userForm.role[0]) &&
                //     this.userForm.role[1] == null)
                // ) {
                //   this.userForm.role.forEach((v) => {
                //     this.roleArr.forEach((v2) => {
                //       if (v2.dictName === v) {
                //         roleIdArr.push(v2.dictId);
                //         roleNameArr.push(v2.dictName);
                //       }
                //     });
                //   });
                // } else if (
                //   (!reg.test(this.userForm.role[0]) &&
                //     !reg.test(this.userForm.role[1])) ||
                //   (!reg.test(this.userForm.role[0]) &&
                //     this.userForm.role[1] == null)
                // ) {
                //   this.userForm.role.forEach((v) => {
                //     this.roleArr.forEach((v2) => {
                //       if (v2.dictId === v) {
                //         roleNameArr.push(v2.dictName);
                //         roleIdArr.push(v2.dictId);
                //       }
                //     });
                //   });
                // } else if (
                //   reg.test(this.userForm.role[0]) &&
                //   !reg.test(this.userForm.role[1])
                // ) {
                //   this.roleArr.forEach((v) => {
                //     if (v.dictName == this.userForm.role[0]) {
                //       id = v.dictId;
                //       name = v.dictName;
                //     } else if (v.dictId == this.userForm.role[1]) {
                //       id1 = v.dictId;
                //       name1 = v.dictName;
                //     }
                //     roleIdArr = [id, id1];
                //     roleNameArr = [name, name1];
                //   });
                // }
                // this.editRoleName = [];
                // this.userForm.role.forEach((v) => {
                //   this.roleArr.forEach((v2) => {
                //     if (v2.dictId == v) {
                //       this.editRoleName.push(v2.dictName);
                //     }
                //   });
                // });
                this.$api.afterPeople
                  .edit({
                    name: this.userForm.name,
                    phone: this.userForm.phone,
                    userRoleId: this.userForm.role,
                    // roleName: this.editRoleName.join(","),
                    password: this.userForm.newPwd
                      ? this.userForm.newPwd
                      : null,
                    id: this.tableSelection[0].id,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("修改成功", "success");
                      this.addORUpdateVisible = false;
                      this.getList();
                    }
                  });
              })
              .catch(() => {
                return;
              });
          }
        } else {
          return false;
        }
      });
    },

    del() {
      if (this.tableSelection.length !== 1) {
        this.$message.error("请选中一行数据");
        return;
      }
      if (this.tableSelection[0].type == 1) {
        this.$message.error("无法操作管理员,请重新选择!");
        return;
      }
      if (this.tableSelection[0].status === 0) {
        this.$message.error("已启用的员工无法删除");
        return;
      }
      handleConfirm(`确认删除该员工吗`, "info")
        .then(() => {
          this.$api.afterPeople
            .del({
              id: this.tableSelection[0].id,
            })
            .then((res) => {
              if (res.code === 200) {
                handleAlert("删除成功", "success");
                this.getList();
              }
            });
        })
        .catch(() => {
          return;
        });
    },

    enable() {
      if (this.tableSelection.length !== 1) {
        this.$message.error("请选中一行数据");
        return;
      }
      if (this.tableSelection[0].type == 1) {
        this.$message.error("无法操作管理员,请重新选择!");
        return;
      }
      if (this.tableSelection[0].status == 0) {
        this.$message.error("该数据已启用，请勿重复操作");
        return;
      }
      handleConfirm(`确认启用该员工吗`, "info")
        .then(() => {
          this.$api.afterPeople
            .edit({ id: this.tableSelection[0].id, status: 0 })
            .then((res) => {
              if (res.code === 200) {
                handleAlert("修改成功", "success");
                this.getList();
              }
            });
        })
        .catch(() => {
          return;
        });
    },

    disable() {
      if (this.tableSelection.length !== 1) {
        this.$message.error("请选中一行数据");
        return;
      }
      if (this.tableSelection[0].type == 1) {
        this.$message.error("无法操作管理员,请重新选择!");
        return;
      }
      if (this.tableSelection[0].status == 1) {
        this.$message.error("该数据已禁用，请勿重复操作");
        return;
      }
      handleConfirm(`确认禁用该员工吗`, "info")
        .then(() => {
          this.$api.afterPeople
            .edit({ id: this.tableSelection[0].id, status: 1 })
            .then((res) => {
              if (res.code === 200) {
                handleAlert("修改成功", "success");
                this.getList();
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    getRole() {
      this.$api.staff.staffRolePull().then((res) => {
        console.log(res, "角色下拉");
        if (res.code === 200) {
          this.roleArr = res.data;
          // this.roleArr = [];
          // arr.forEach((v) => {
          //   if (v.dictPid !== 0) {
          //     this.roleArr.push(v);
          //   }
          // });
        }
      });
    },

    add() {
      this.userForm = {
        phone: "",
        name: "",
        pwd: "",
        role: "",
        oldPwd: "",
        newPwd: "",
        surePwd: "",
      };
      this.addORUpdateVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.userForm.clearValidate();
      });
    },
    update() {
      if (this.tableSelection.length !== 1) {
        this.$message.error("请选中一行数据");
        return;
      }

      let demo = this.tableSelection[0];
      this.userForm.phone = demo.phone;
      this.userForm.name = demo.name;
      // if (demo.roleId) {
      //   let roleArr = [];
      //   let arr = demo.roleId.split(",");
      //   arr.forEach((v) => {
      //     roleArr.push(Number(v));
      //   });
      //   this.userForm.role = roleArr;
      // } else {
      //   this.userForm.role = "";
      // }
      this.userForm.role = Number(demo.userRoleId);

      this.addORUpdateVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.userForm.clearValidate();
      });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    tableSelectionChange(val) {
      this.tableSelection = val;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    reset() {
      this.searchForm = { startTime: "", endTime: "" };
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
